import styled, { css } from 'styled-components';
const noMargin = css `
  margin: 0;
`;
const marginStyles = ({ marginBottom }) => {
    if (!marginBottom) {
        return undefined;
    }
    return `margin-bottom: ${marginBottom === true ? '10px' : `${marginBottom}px`};`;
};
const Headline = styled.h1 `
  ${noMargin}
  ${({ theme }) => theme.typography.headline}
  ${({ color }) => color && {
    color,
}}
`;
const Title = styled.h3 `
  ${noMargin}
  ${({ theme }) => theme.typography.title}
  ${({ color }) => color && {
    color,
}}
`;
const SubTitle = styled.h5 `
  ${noMargin}
  ${({ theme }) => theme.typography.titleSub}
  ${({ color }) => color && {
    color,
}}
`;
const TextLarge = styled.p `
  ${noMargin}
  ${({ theme }) => theme.typography.textLarge}
  ${marginStyles}
  & b, strong {
    ${({ theme }) => theme.typography.weightMedium}
  }
  ${({ color }) => color && {
    color,
}}
`;
const TextMedium = styled.p `
  ${noMargin}
  ${({ theme }) => theme.typography.textMedium}
  ${marginStyles}
  & b, strong {
    ${({ theme }) => theme.typography.weightMedium}
  }
  ${({ color }) => color && {
    color,
}}
`;
const TextSmall = styled.p `
  ${noMargin}
  ${({ theme }) => theme.typography.textSmall}
  ${marginStyles}
  & b, strong {
    ${({ theme }) => theme.typography.weightMedium}
  }
  ${({ color }) => color && {
    color,
}}
`;
const TextExtraSmall = styled.p `
  ${noMargin}
  ${({ theme }) => theme.typography.textExtraSmall}
  ${marginStyles}
  & b, strong {
    ${({ theme }) => theme.typography.weightMedium}
  }
  ${({ color }) => color && {
    color,
}}
`;
const Typography = () => null;
Typography.Headline = Headline;
Typography.Title = Title;
Typography.SubTitle = SubTitle;
Typography.TextLarge = TextLarge;
Typography.TextMedium = TextMedium;
Typography.TextSmall = TextSmall;
Typography.TextExtraSmall = TextExtraSmall;
export default Typography;
